import { Pagination } from "../base/Pagination";

// Notification Types
//Comments inside here is what kind of items changed that is returned and in the respective order
export enum UsersNotificationType {
  WorkspaceDocumentUpdated = "WorkspaceDocumentUpdated", //[documentName, workspaceName]
  WorkspaceDocumentUploaded = "WorkspaceDocumentUploaded", //[documentName, workspaceName]
  WorkspaceDocumentsUploaded = "WorkspaceDocumentsUploaded", // [numberOfDocuments, workspaceName, documentNames]
  WorkspaceDocumentRemoved = "WorkspaceDocumentRemoved", // [numberOfDocuments, workspace.Name]
  WorkspaceAccessGranted = "WorkspaceAccessGranted", // [role, workspaceName]
  WorkspaceAccessRevoked = "WorkspaceAccessRevoked", // [ workspaceName ]
  DocumentUpdated = "DocumentUpdated",
  CommentAdded = "CommentAdded",
  ConversationStarted = "ConversationStarted",
  MessageReceived = "MessageReceived",
  ReviewCompleted = "ReviewCompleted",
  SystemAlert = "SystemAlert",
  UserMentioned = "UserMentioned",
  WorkspaceFolderAdded = "WorkspaceFolderAdded", // [folderName, workspaceName]
  WorkspaceDeleted = "WorkspaceDeleted", // [workspaceName],
  WorkspaceDocumentsMoved = "WorkspaceDocumentsMoved", // [docCount, folderName, workspaceName],
  WorkspaceFolderMoved = "WorkspaceFolderMoved", // [folderName, toFolderName]
  WorkspaceFolderMovedToRoot = "WorkspaceFolderMovedToRoot", // [folderName, workspaceName]
  WorkspaceFolderRemoved = "WorkspaceFolderRemoved", // [folderName, workspaceName]
  WorkspaceUpdated = "WorkspaceUpdated", // [workspaceName]
  WorkspaceFolderUpdated = "WorkspaceFolderUpdated", // [newFolderName, workspaceName]
  WorkspaceCommentCreated = "WorkspaceCommentCreated", // [workspaceName],
  WorkspaceCommentReacted = "WorkspaceCommentReacted", // []
  WorkspaceCommentRepliedTo = "WorkspaceCommentRepliedTo", // []
  WorkspaceCommentUpdated = "WorkspaceCommentUpdated",
  WorkspaceRoleUpdated = "WorkspaceRoleUpdated", // [role, workspaceName]
  WorkspaceDocumentsMovedToRoot = "WorkspaceDocumentsMovedToRoot", // [docCount, workspaceName]
  DocumentLinkAutomaticallyUpdated = "DocumentLinkAutomaticallyUpdated", // document link automatically updated (legislation path)
  LegislationUpdated = "LegislationUpdated", // [legislationName, datasource]
  LegislationCreated = "LegislationCreated", // [legislationName, datasource]
  LegislationIsHistoric = "LegislationIsHistoric", // [legislationName, datasource]
  LegislationMetadataUpdated = "LegislationMetadataUpdated", // [legislationName, datasource]
  LegislationTimelineChanged = "LegislationTimelineChanged", // [legislationName, datasource]
  LegislationSubscriptionUpdated = "LegislationSubscriptionUpdated", // [legislationName, datasource]
  GroupMessage = "GroupMessage", // Message sent to group (admin)
  GroupMemberAdded = "GroupMemberAdded",
  GroupMemberRemoved = "GroupMemberRemoved",
  GroupNameUpdated = "GroupNameUpdated",
  GroupDeleted = "GroupDeleted",
  GroupAddedToSubscription = "GroupAddedToSubscription",
  GroupRemovedFromSubscription = "GroupRemovedFromSubscription",
  PiiOverride = "PiiOverride", // a user overrode PII anonymisation in a chat (LAR-27)
  // Appended last, like on the API, so numeric payloads keep mapping by position.
  WorkspaceLinkAdded = "WorkspaceLinkAdded", // [linkName, workspaceName]
  WorkspaceLinkUpdated = "WorkspaceLinkUpdated", // [newLinkName, workspaceName]
  WorkspaceLinkMoved = "WorkspaceLinkMoved", // [linkName, toFolderName]
  WorkspaceLinkMovedToRoot = "WorkspaceLinkMovedToRoot", // [linkName, workspaceName]
  WorkspaceLinkRemoved = "WorkspaceLinkRemoved", // [linkName, workspaceName]
}

export enum UsersNotificationSubscriptionStatus {
  Active = "Active",
  Seen = "Seen",
  Dismissed = "Dismissed",
  Deleted = "Deleted",
}

export enum UsersNotificationSettingsType {
  Workspace = "Workspace",
  PiiOverride = "PiiOverride",
}

// Notification Subscription
export interface NotificationSubscription {
  userId: string;
  status: UsersNotificationSubscriptionStatus;
  deletedOn?: string;
}

// Notification View Model (what comes from SignalR / API)
export interface Notification {
  id: string;
  type: UsersNotificationType;
  entityPath: string;
  text: string;
  itemsChanged: string[];
  actionCausedById: string;
  actionCausedByName: string;
  createdAt: string;
  updatedAt: string;
  deletedOn?: string | null;
  isDeleted: boolean;
  status: UsersNotificationSubscriptionStatus;
  /** Document identifier for grouping (e.g. legislation externalId or document link). null when not applicable. */
  documentId?: string | null;
  /** Display name for the document. null when not applicable. */
  documentName?: string | null;
}

// Notification Settings
export interface MyNotificationSettingsResponseModel {
  workspaceSubscriber: boolean;
}

// API Response Types
export type GetNotificationsResponse = Pagination<Notification>;
export interface GetActiveCountResponse {
  count: number;
}

// SignalR Connection State
export enum ConnectionState {
  Connecting = "Connecting",
  Connected = "Connected",
  Reconnecting = "Reconnecting",
  Disconnected = "Disconnected",
}

// Hook Return Type
export interface UseNotificationsReturn {
  notifications: Notification[];
  activeCount: number;
  connectionState: ConnectionState;
  isLoading: boolean;
  error: string | null;
  //   markAsRead: (notificationId: string) => Promise<void>;
  //   markAllAsRead: () => Promise<void>;
  //   updateNotificationSettings: (
  //     settingsType: UsersNotificationSettingsType,
  //     enabled: boolean
  //   ) => Promise<void>;
  //   getNotificationSettings: () => Promise<MyNotificationSettingsResponseModel>;
  refetch: () => Promise<void>;
}
